import { Input } from 'antd';
import React from 'react';
import './OptionDescriptionSetting.scss';

interface OptionDescriptionSettingProps {
  value?: string;
  onChange: (value: string) => void;
  previewLabel?: string;
  previewPrice?: number;
}

export const OptionDescriptionSetting: React.FC<OptionDescriptionSettingProps> = (props) => {
  const { value = '', onChange, previewLabel = '1/12(목) / 1:30 / 고구려', previewPrice = 220000 } = props;

  return (
    <div className="option-description-setting">
      <div className="option-description-setting__form">
        <div className="option-description-setting__title">구매 항목 보조 문구 설정</div>
        <Input
          placeholder="보조문구 입력"
          maxLength={20}
          showCount
          value={value}
          onChange={(e) => onChange(e.target.value || '')}
        />
        <div className="option-description-setting__helper">
          구매 항목 보조 문구 설정 시, 수량 선택 단계에서 알아야 할 내용을 전달할 수 있습니다.
        </div>
      </div>
      <div className="option-description-setting__preview">
        <div className="option-description-setting__preview-card">
          <div className="option-description-setting__preview-header">
            <span>수량 선택</span>
            <span className="option-description-setting__preview-chevron">⌃</span>
          </div>
          <div className="option-description-setting__preview-body">
            <div className="option-description-setting__preview-option">{previewLabel}</div>
            <div className="option-description-setting__preview-description">{value}</div>
            <div className="option-description-setting__preview-footer">
              <div className="option-description-setting__preview-price">{previewPrice.toLocaleString()}원</div>
              <div className="option-description-setting__preview-stepper">
                <span>-</span>
                <span>0</span>
                <span>+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
